import { observable, action, makeObservable } from 'mobx'
import { DocumentDetailsModalViewModel } from '../DocumentDetailsModal/DocumentDetailsModalViewModel'
import Document from 'documents/Document'
import { Id } from 'types/definitions'
import { DocumentDetailsModalPorts } from '../DocumentDetailsModal/ports'

export type ViewDocumentDetailsDelegate = (
  document: Document,
  viewAsAdmin?: boolean,
) => DocumentDetailsModalViewModel

export class DocumentDetailsRootViewModel {
  private documentDetailsVMs = new Map<string, DocumentDetailsModalViewModel>()

  @observable
  public selectedDocDetailsModalVM: DocumentDetailsModalViewModel | null = null

  constructor(private adapter: DocumentDetailsModalPorts) {
    makeObservable(this)
    this.viewDocumentDetails = this.viewDocumentDetails.bind(this)
  }

  @action.bound
  setDocumentDetailsDocumentVM(vm: DocumentDetailsModalViewModel) {
    if (this.selectedDocDetailsModalVM) {
      this.selectedDocDetailsModalVM.close()
      this.selectedDocDetailsModalVM.deactivate()
    }
    this.selectedDocDetailsModalVM = vm
    if (vm) {
      vm.show()
      vm.activate()
    }
  }

  viewDocumentDetails(document: Document, viewAsAdmin?: boolean) {
    const docId = Id.assert(document.id)

    const existing = this.documentDetailsVMs.get(docId)
    if (existing) {
      existing.setViewAsAdmin(viewAsAdmin ?? false)
      this.setDocumentDetailsDocumentVM(existing)
      return existing
    }

    const vm = this.createDocumentDetailsModalVM(document, viewAsAdmin)
    this.documentDetailsVMs.set(docId, vm)
    this.setDocumentDetailsDocumentVM(vm)
    return vm
  }

  private createDocumentDetailsModalVM(
    document: Document,
    viewAsAdmin?: boolean,
  ) {
    return new DocumentDetailsModalViewModel(
      document,
      this.adapter,
      viewAsAdmin,
    )
  }
}
